import { db, docFromSnapshot } from "../../firebase";
import _ from "lodash";
import Vue from "vue";

const state = {
  invoiceItemHistory: {
    globalHistory: {},
    customerHistories: {}
  },
  applicableInvoiceItemHistory: {}
};

const getters = {
  invoiceItemHistory: state => state.invoiceItemHistory,
  applicableInvoiceItemHistory: state => state.applicableInvoiceItemHistory
};

const actions = {
  async fetchInvoiceItemHistory({ commit, getters }) {
    const snapshot = await db
      .collection("invoice-item-history")
      .doc(getters.tenantId)
      .get();

    const invoiceItemHistory = docFromSnapshot(snapshot);
    if (invoiceItemHistory) {
      commit("setInvoiceItemHistory", invoiceItemHistory);

      if (_.isEmpty(getters.applicableInvoiceItemHistory)) {
        commit(
          "setApplicableInvoiceItemHistory",
          invoiceItemHistory.globalHistory
        );
      }
    }
  },
  applyCustomerInvoiceItemHistory({ commit, getters }, customerId) {
    const invoiceItemHistory = getters.invoiceItemHistory;
    commit("setApplicableInvoiceItemHistory", {
      ..._.get(invoiceItemHistory, "globalHistory", {}),
      ..._.get(invoiceItemHistory, `customerHistories[${customerId}]`, {})
    });
  }
};

const mutations = {
  setInvoiceItemHistory(state, invoiceItemHistory) {
    Vue.set(state, "invoiceItemHistory", invoiceItemHistory);
  },
  setApplicableInvoiceItemHistory(state, invoiceItemHistory) {
    Vue.set(state, "applicableInvoiceItemHistory", invoiceItemHistory);
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};
